import moment from 'moment';
moment.locale('sv');

const state = {
    glitter: false,
    loading: false,
    saveStatus: '',
    headerDropdown: false,
    toggledMobile: false,
    snackbar: null,
    currentMonthMM: moment().format('MMMM'),
    mainBackgroundColorClass: '',
};

const mutations = {
    SET_BACKGROUND: (state, className) => (state.mainBackgroundColorClass = className),
    SET_HEADER_DROPDOWN: (state) => (state.headerDropdown = !state.headerDropdown),
    SET_SAVE_STATUS: (state, status) => (state.saveStatus = status),
    SET_GLITTER: (state, bool) => (state.glitter = bool),
    SET_LOADING: (state, bool) => (state.loading = bool),
    CLEAR_SNACKBAR: (state) => (state.snackbar = null),
    RESET_SAVE_STATUS: (state) => (state.saveStatus = ''),
    TOGGLE_MOBILE_NAV: (state) => {
        state.toggledMobile = !state.toggledMobile;
        state.headerDropdown = false; // Close dropdown for desktop if it stays open in the background on mobile
    },
    SET_SNACKBAR(state, obj) {
        state.snackbar = {
            show: !!(obj.status && obj.message),
            status: obj.status,
            message: obj.message,
            confetti: 'confetti' in obj ? obj.confetti : false,
            btnText: 'btnText' in obj ? obj.btnText : null,
            btnHref: 'btnHref' in obj ? obj.btnHref : null,
            delayTime: 'delayTime' in obj ? obj.delayTime : null,
        };
    },
};

const actions = {
    async SET_SNACKBAR({ commit }, data) {
        await commit('SET_SNACKBAR', data);
    },
    RESET_STORES({ commit }) {
        commit('SuperAdminStore/RESET_STATE', null, { root: true });
        commit('AuthStore/RESET_STATE', null, { root: true });
        commit('SingleCertificate/RESET_STATE', null, { root: true });
        commit('RegisterStore/RESET_STATE', null, { root: true });
        commit('Departments/RESET_STATE', null, { root: true });
        commit('UserStore/RESET_STATE', null, { root: true });
        commit('BankID/RESET_STATE', null, { root: true });
    },
};

const getters = {
    getHeaderDropdown: (state) => state.headerDropdown,
    GET_SAVE_STATUS: (state) => state.saveStatus,
    GET_SNACKBAR: (state) => state.snackbar,
    GET_GLITTER: (state) => state.glitter,
    GET_LOADING: (state) => state.loading,
    GET_CURRENT_MONTH_MM: (state) => state.currentMonthMM,
    GET_MOBILE_TOGGLER: (state) => state.toggledMobile,
    GET_BACKGROUND: (state) => state.mainBackgroundColorClass,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
